
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Reference extends Vue {
  @Prop() private reference!: object;
}
